import React from "react";
import "./notApplicable.scss";
import { NotApplicableMessage } from "constants/constants";
import { project } from "utils/enums";
function NotApplicable({ children, projectname }) {
  return (
    <>
      {projectname === project.BO ? (
        <h6 className="unauth">{NotApplicableMessage}</h6>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

export default NotApplicable;
